export default {
  alert: {
    alertMessage: 'Es posible que las publicaciones de TikTok no incluyan datos de sentimiento, temas o etiquetas. Las páginas de TikTok siguen disponibles para seleccionar, pero estos filtros pueden no devolver resultados.',
    linkText: 'Más información en el Centro de ayuda',
  },
};
